// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sRP5O","left":"styles_left__4dBIj","desktopActions":"styles_desktopActions__23L4d","title":"styles_title__GSsco"};